import { Component, OnInit } from '@angular/core';
import { SeoService } from 'src/app/services/seo.service';

@Component({
  selector: 'app-rpa',
  templateUrl: './rpa.component.html',
  styleUrls: ['./rpa.component.scss']
})
export class RpaComponent implements OnInit {
  constructor(private readonly seo: SeoService) {}

  ngOnInit(): void {
    this.seo.update({
      title: 'Robotic Process Automation & Intelligent Automation | DotBlack',
      description: 'Reduce repetitive work and improve response times with RPA, chatbots, AI-enabled workflows and intelligent automation.',
      path: '/rpa/',
      type: 'website',
      schema: { '@context': 'https://schema.org', '@type': 'Service', name: 'Intelligent Automation', provider: { '@type': 'Organization', name: 'DotBlack Projex Pty (Ltd)', url: 'https://dotblack.co.za/' }, url: 'https://dotblack.co.za/rpa/' }
    });
  }
}
